import styled from 'styled-components';
import { TransparentButton, Typography } from '@libs/components';

type CustomItemProps = {
  disabled?: boolean;
};
export const ItemWrapper = styled(TransparentButton)<CustomItemProps>`
  display: flex;
  align-items: center;
  width: 21.4rem;
  padding: 0.8rem;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const ItemIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
  width: 4.4rem;
  height: 4.4rem;
  min-width: 4.4rem;
  margin-right: 1.2rem;
`;

export const ComingSoonTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.8rem;
  margin-left: 0.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.x2};
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const CustomTypography = styled(Typography)`
  text-align: start;
`;
